export default __webpack_public_path__ + "static/media/results.6b4595ad.webp";